import {
	cookie_setParticipantsNum,
	cookie_setParticipantsAges,
} from "@/logic/cookies";
import { setHash } from "@/utils/utils";
import searchPrestationsForFilter from "@/vue/planning/logic/searchPrestationsForFilter";

export default {
	setParticipants: async (storeObj, newArray) => {
		const { commit, state, dispatch } = storeObj;

		// set cookies
		cookie_setParticipantsNum(newArray.length);
		cookie_setParticipantsAges(newArray);

		const currentParticipants = [...state.participants];

		// set state
		commit("setParticipants", newArray);
		dispatch("setParticipantsDropdownOpen", false); // close dropdown

		// reset selected prestations
		commit("clearSelectedPrestIds");

		// Reset flex types
		commit("clearSelectedFlexTypes")

		// clear selected fusions
		commit("clearSelectedPrestIdFusions")

		if (JSON.stringify(newArray) === JSON.stringify(currentParticipants))
			return; // ignore if same
		await searchPrestationsForFilter(storeObj); // search, and it will automatically refresh data on finish
	},

	setPackage: async (storeObj, newPackCode) => {
        storeObj.dispatch('queueAction', () => new Promise(async (resolve, reject) => {
            try {
                const { commit, dispatch } = storeObj;

                // Set hash
                setHash({ packCode: newPackCode });

                // Set state
                commit("setPackage", newPackCode);
                dispatch("setPackagesMobileDropdownOpen", false); // close dropdown

                // Reset selected prestations
                commit("clearSelectedPrestIds");

                // Reset flex types
                commit("clearSelectedFlexTypes");

                // Clear selected fusions
                commit("clearSelectedPrestIdFusions");

                await searchPrestationsForFilter(storeObj); // search, and it will automatically refresh data on finish
                dispatch("refreshDataStoredOnWindow"); // refresh data, do not search

                resolve();
            } catch (error) {
                console.error('Failed to process setPackage action:', error);
                reject(error);
            }
        }));

	},

	setPackageId: (storeObj, packageId) => {
		const { commit, dispatch } = storeObj;
	},

	setDates: async (storeObj, datesObj) => {
        storeObj.dispatch('queueAction', () => new Promise(async (resolve, reject) => {
            try {
                const { commit, state, dispatch } = storeObj;
                const startDate = datesObj["BeginDate"] || "";
                const endDate = datesObj["EndDate"] || "";
                const currentDates = { ...state.dates };

                // Check if new dates are the same as current dates to avoid unnecessary processing
                if (JSON.stringify(datesObj) === JSON.stringify(currentDates)) {
                    resolve();
                    return; // Ignore if the same
                }

                // Set hash
                const obj = {};
                if (startDate) obj["BeginDate"] = startDate;
                if (endDate) obj["EndDate"] = endDate;
                setHash(obj);

                // Set state
                if (startDate) commit("setStartDate", startDate);
                if (endDate) commit("setEndDate", endDate);

                dispatch("setDatepickerOpen", ""); // Close dropdown

                // Reset selected prestations
                commit("clearSelectedPrestIds");

                // Reset flex types
                commit("clearSelectedFlexTypes");

                // Clear selected fusions
                commit("clearSelectedPrestIdFusions");

                // Search prestations and refresh data
                await searchPrestationsForFilter(storeObj);
                resolve();
            } catch (error) {
                console.error('Failed to process setDates action:', error);
                reject(error);
            }
        }));
	},
	processQueue({ commit, state }) {
		if (state.isProcessingQueue) {
			return;
		}
		commit('startQueueProcessing');
		const processNext = () => {
			if (state.actionQueue.length > 0) {
				const action = state.actionQueue.shift();
				action().then(processNext).catch(error => {
					console.error('Error processing action:', error);
					processNext();
				});
			} else {
				commit('finishQueueProcessing');
			}
		};
		processNext();
	},
	queueAction({ commit, dispatch }, action) {
		commit('enqueueAction', action);
		dispatch('processQueue');
	}
};
